var _linearGradient, _polygon, _linearGradient2, _path, _linearGradient3, _polygon2, _linearGradient4, _polygon3, _linearGradient5, _polygon4, _linearGradient6, _polygon5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -1582,
    x2: -1581,
    y1: -1495.328,
    y2: -1495.328,
    gradientTransform: "rotate(-45 32051.159 -83912.245) scale(31.584)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c757bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#c757bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#cd5ca9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#e8744f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#f88316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#ff8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8900"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#a)",
    points: "24 0 12.05 0 .639 12 11.979 12 12.032 11.946 24 0"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -1582,
    x2: -1581,
    y1: -1494.622,
    y2: -1494.622,
    gradientTransform: "rotate(-45 15635.387 -40897.94) scale(15.3946)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00afff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00afff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945dff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M24,24H0H24L24,24z M12.032,11.946L11.979,12h0.107L12.032,11.946L12.032,11.946z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -1582,
    x2: -1581,
    y1: -1494.036,
    y2: -1494.036,
    gradientTransform: "matrix(7.6364 -7.6366 7.6366 7.6364 23489.887 -665.412)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00afff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00afff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945dff"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#c)",
    points: "12.05 0 0 0 0 12.672 0 12 .639 12 12.05 0"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -1582,
    x2: -1581,
    y1: -1495.322,
    y2: -1495.322,
    gradientTransform: "rotate(-45 32051.159 -83912.245) scale(31.584)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad4ca4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#ad4ca4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#b25093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#ca6545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#d87213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#de7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de7700"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#d)",
    points: "11.979 12 .639 12 0 12.672 0 24 11.979 12"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -1582,
    x2: -1581,
    y1: -1494.622,
    y2: -1494.622,
    gradientTransform: "rotate(-45 15635.387 -40897.94) scale(15.3946)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0098de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#0098de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#4771de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8151de"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#e)",
    points: "12.086 12 11.979 12 0 24 24 24 12.086 12"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -1582,
    x2: -1581,
    y1: -1493.643,
    y2: -1493.643,
    gradientTransform: "matrix(7.6364 -7.6366 7.6366 7.6364 23489.887 -665.412)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0098de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#0098de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#4771de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8151de"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#f)",
    points: ".639 12 0 12 0 12.672 .639 12"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.93edde306fe495d9b2e0e4fd7c98313a.svg";
export { ForwardRef as ReactComponent };